<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 custom-title">{{ $t('meeting_report') }}</h3>
        </div>
    </div>
    <div id="search">
        <div class="form-group">
            <div class="input-wrapper">
                <label class="label" for="pin">{{ $t('meeting_type')  }}</label>
                <select as="select" class="form-control custom-select" v-model="filter_meeting" name="filter_type"
                    id="select4">
                    <option value>---{{ $t('select') }}---</option>
                    <option v-for="meeting in meeting_list" v-bind:value="meeting.id" v-bind:key="meeting.id">{{
                        meeting.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group" v-if="user_level === 1">
            <div class="input-wrapper">
                <label class="label" for="region">{{ $t('region') }}</label>
                <select class="form-control custom-select" v-model="filter_region" name="filter_region" id="filter_region">
                    <option value="kerala">{{ $t('kerala') }}</option>
                    <option value="outside">{{ $t('out_of_kerala') }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <div class="input-wrapper">
                        <label class="label" for="pin">{{ $t('date_from') }}</label>
                        <input type="date" class="form-control" name="filter_date_from" v-model="filter_date_from" />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                    <ErrorMessage name="date_from" class="error-feedback" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <div class="input-wrapper">
                        <label class="label" for="pin">{{ $t('date_to') }}</label>
                        <input type="date" class="form-control" name="filter_date_to" v-model="filter_date_to" />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>
                    <ErrorMessage name="date_to" class="error-feedback" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilter()">
                    <ion-icon name="trash-bin-outline" role="img" class="md hydrated" aria-label="add outline"></ion-icon>
                    {{ $t('clear') }}
                </button>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                    @click="getMembersList()">
                    <ion-icon name="search-outline" role="img" class="md hydrated" aria-label="add outline"></ion-icon>
                    {{ $t('search') }}
                </button>
            </div>
        </div>
    </div>
    <div class="section">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ $t('target') }}</div>
                    <div class="value text-danger">{{ count_target }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ $t('confirmed') }}</div>
                    <div class="value text-success">{{ count_confirmed }}</div>
                </div>
            </div>
            <div class="col-12 pt-1">
                <div class="stat-box">
                    <div class="title mal-text text-primary">{{ $t('increase') }}</div>
                    <div class="value text-success">{{ count_total }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Wisdom Day "not held" report (state admin only) -->
    <div class="section mt-1" v-if="showNotHeldReport">
        <button type="button" class="btn btn-outline-primary btn-sm w-100" style="border-radius:8px;" @click="toggleNotHeldReport">
            <ion-icon name="alert-circle-outline"></ion-icon>
            നടക്കാത്ത മണ്ഡലം / ശാഖ റിപ്പോർട്ട്
            <ion-icon :name="nh_open ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </button>

        <div v-if="nh_open" class="card mt-2 p-2" style="border-radius:12px;">
            <!-- Zones / Units toggle -->
            <div style="display:flex;gap:6px;margin-bottom:8px;">
                <button type="button" class="nh-tab" @click="nh_view='zones'"
                    :style="nh_view==='zones' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                    നടക്കാത്ത മണ്ഡലം ({{ nh_zones.length }})
                </button>
                <button type="button" class="nh-tab" @click="nh_view='units'"
                    :style="nh_view==='units' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                    നടക്കാത്ത ശാഖ ({{ nh_units.length }})
                </button>
            </div>

            <div v-if="nh_loading" class="text-center py-3"><div class="spinner-border text-primary"></div></div>

            <template v-else>
                <!-- Zones not held (grouped by district) -->
                <div v-if="nh_view==='zones'">
                    <div v-if="!nh_zones.length" class="text-center text-success py-3" style="font-size:13px;">
                        എല്ലാ മണ്ഡലങ്ങളിലും നടന്നു ✅
                    </div>
                    <div v-for="(dg, di) in nhZonesByDistrict" :key="'nhz_'+di" class="mb-2">
                        <div style="font-size:12px;font-weight:800;color:#c0392b;margin-bottom:4px;">{{ dg.district_name }}</div>
                        <div v-for="z in dg.zones" :key="'z_'+z.zone_id"
                            style="display:flex;align-items:center;justify-content:space-between;background:#fff5f5;border:1px solid #f5c6c6;border-radius:8px;padding:8px 12px;margin-bottom:5px;">
                            <span style="font-size:13px;font-weight:700;color:#27173E;">{{ z.zone_name }}</span>
                            <span style="font-size:11px;color:#94a3b8;">{{ z.units_count }} ശാഖ</span>
                        </div>
                    </div>
                </div>

                <!-- Units not held (grouped by district → zone) -->
                <div v-else>
                    <div v-if="!nh_units.length" class="text-center text-success py-3" style="font-size:13px;">
                        എല്ലാ ശാഖകളിലും നടന്നു ✅
                    </div>
                    <div v-if="nh_units.length" class="mb-2">
                        <select v-model="nh_unit_zone_filter" class="form-control custom-select">
                            <option value="">എല്ലാ മണ്ഡലം ({{ nh_units.length }})</option>
                            <option v-for="z in nhUnitZoneOptions" :key="'nhzf_'+(z.zone_id || z.zone_name)" :value="z.zone_id">
                                {{ z.zone_name }} ({{ z.count }})
                            </option>
                        </select>
                    </div>
                    <div v-for="(dg, di) in nhUnitsByDistrict" :key="'nhu_'+di" class="mb-2">
                        <div style="font-size:12px;font-weight:800;color:#c0392b;margin-bottom:4px;">{{ dg.district_name }}</div>
                        <div v-for="(zg, zi) in dg.zones" :key="'nhuz_'+zi" style="margin-bottom:6px;">
                            <!-- Zone header: name + unit count + collapse chevron -->
                            <div @click="toggleNhZone(zg.zone_key)"
                                style="display:flex;align-items:center;justify-content:space-between;background:#eef2ff;border:1px solid #dbe3ff;border-radius:8px;padding:8px 12px;cursor:pointer;">
                                <span style="font-size:13px;font-weight:700;color:#1a418c;">{{ zg.zone_name }}</span>
                                <span style="display:flex;align-items:center;gap:6px;">
                                    <span style="font-size:11px;font-weight:700;color:#c0392b;background:#fff;border-radius:10px;padding:1px 8px;">{{ zg.units.length }}</span>
                                    <ion-icon :name="isNhZoneCollapsed(zg.zone_key) ? 'chevron-down-outline' : 'chevron-up-outline'" style="font-size:15px;color:#1a418c;"></ion-icon>
                                </span>
                            </div>
                            <!-- Units (collapsed by default) -->
                            <div v-show="!isNhZoneCollapsed(zg.zone_key)" style="padding:4px 0 2px;">
                                <div v-for="u in zg.units" :key="'u_'+u.unit_id"
                                    style="background:#fff5f5;border:1px solid #f5c6c6;border-radius:8px;padding:7px 12px;margin:4px 0 0;font-size:13px;font-weight:700;color:#27173E;">
                                    {{ u.unit_name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">{{ $t('no_members_added') }}</h4>
    </div>
    <div class="modal fade action-sheet" id="nerpathamTargetModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('nerpatham_target') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addNerpathamTarget">
                            <div class="form-group basic">
                                <label class="label" for="Target">{{ $t('target') }}</label>
                                <div class="form-group boxed">
                                    <Field name="target" type="number" class="form-control" id="target"
                                        v-model="nerpatham_target" placeholder="Enter Target" />
                                </div>
                                <input type="hidden" v-model="sub_level_id">
                                <div class="form-group" v-if="message">
                                    <div v-if="message" class="error-feedback">
                                        {{ message }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list">
        <!-- Desktop Table View -->
        <div class="report-container desktop-view" v-if="!isCompactStatusTableView">
            <div class="table-responsive">
                <table class="table table-classic">
                    <thead>
                        <tr>
                            <th scope="col" class="col-name">{{ $t('name') }}</th>
                            <th scope="col" class="col-status" v-if="user_level != 3">
                                <div class="header-multiline">{{$t('decided')}}<br>{{$t('confirmed')}}<br>{{ $t('happened') }}</div>
                            </th>
                            <th scope="col" class="col-status" v-if="user_level == 3">{{ $t('status') }}</th>
                            <th scope="col" class="col-attendance">{{ $t('attendance') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in member_lists" v-bind:key="sub_level.id" class="report-row">
                            <td class="cell-name">
                                <span v-if="user_level <= 2" class="name-link">
                                    <router-link :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/meeting-report?meeting_type='+this.filter_meeting+'&&date_from='+this.filter_date_from+'&&date_to='+this.filter_date_to+''">
                                        {{ sub_level.name }}
                                    </router-link>
                                </span>
                                <span v-if="user_level == 3" class="name-text">{{ sub_level.name }}</span>
                            </td>
                            <td class="cell-status">
                                <div class="status-content">
                                    <template v-if="user_level != 3">
                                        <div class="status-chips" v-if="sub_level.meeting_status">
                                            <span class="chip chip-decided">{{ $t('decided') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[0] }}</span>
                                            <span class="chip chip-confirmed">{{ $t('confirmed') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[1] }}</span>
                                            <span class="chip chip-happened">{{ $t('happened') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[2] }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <span v-html="sub_level.meeting_status"></span>
                                    </template>
                                    <span v-if="sub_level.meeting_date" class="meeting-date-badge" v-html="sub_level.meeting_date"></span>
                                </div>
                            </td>
                            <td class="cell-attendance">
                                <div class="attendance-list">
                                    <div class="attendance-item">
                                        <span class="attendance-badge badge-ws">WS</span>
                                        <span class="attendance-value">{{ sub_level.wing_counts.wisdom }}/{{ sub_level.wing_counts.wisdom_total }}</span>
                                    </div>
                                    <div class="attendance-item">
                                        <span class="attendance-badge badge-yt">YT</span>
                                        <span class="attendance-value">{{ sub_level.wing_counts.youth }}/{{ sub_level.wing_counts.youth_total }}</span>
                                    </div>
                                    <div class="attendance-item">
                                        <span class="attendance-badge badge-st">ST</span>
                                        <span class="attendance-value">{{ sub_level.wing_counts.students }}/{{ sub_level.wing_counts.students_total }}</span>
                                    </div>
                                    <div class="attendance-item">
                                        <span class="attendance-badge badge-wm">WM</span>
                                        <span class="attendance-value">{{ sub_level.wing_counts.women }}/{{ sub_level.wing_counts.women_total }}</span>
                                    </div>
                                    <div class="attendance-item">
                                        <span class="attendance-badge badge-gl">GL</span>
                                        <span class="attendance-value">{{ sub_level.wing_counts.girls }}/{{ sub_level.wing_counts.girls_total }}</span>
                                    </div>
                                    <div class="attendance-total" v-if="sub_level.attendance">
                                        <span class="total-label">Total:</span>
                                        <span class="total-value">{{ sub_level.attendance }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Compact table (State/District): meeting status columns (like sample design) -->
        <div class="report-container desktop-view" v-else>
            <div class="table-responsive">
                <table class="table table-classic table-meeting-status">
                    <thead>
                        <tr>
                            <th scope="col" class="col-name">{{ compactTableNameLabel }}</th>
                            <th scope="col" class="col-status text-center">{{ $t('decided') }}</th>
                            <th scope="col" class="col-status text-center">
                                <span v-html="confirmedHeaderHtml"></span>
                            </th>
                            <th scope="col" class="col-status text-center">{{ $t('happened') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in member_lists" v-bind:key="sub_level.id" class="report-row">
                            <td class="cell-name">
                                <span class="name-link">
                                    <router-link :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/meeting-report?meeting_type='+this.filter_meeting+'&&date_from='+this.filter_date_from+'&&date_to='+this.filter_date_to+''">
                                        {{ sub_level.name }}
                                    </router-link>
                                </span>
                            </td>
                            <td class="cell-status cell-status-number decided">
                                {{ parseMeetingStatusText(sub_level.meeting_status)[0] }}
                            </td>
                            <td class="cell-status cell-status-number confirmed">
                                {{ parseMeetingStatusText(sub_level.meeting_status)[1] }}
                            </td>
                            <td class="cell-status cell-status-number happened">
                                {{ parseMeetingStatusText(sub_level.meeting_status)[2] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Mobile Card View -->
        <div class="mobile-view">
            <template v-if="isCompactStatusTableView">
                <div class="card meeting-status-card">
                    <div class="table-responsive">
                        <table class="table meeting-status-table">
                            <thead>
                                <tr>
                                    <th scope="col">{{ compactTableNameLabel }}</th>
                                    <th scope="col">{{ $t('decided') }}</th>
                                    <th scope="col"><span v-html="confirmedHeaderHtml"></span></th>
                                    <th scope="col">{{ $t('happened') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="sub_level in member_lists" :key="sub_level.id">
                                    <td class="text-primary meeting-status-name">
                                        <router-link
                                            :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/meeting-report?meeting_type='+this.filter_meeting+'&&date_from='+this.filter_date_from+'&&date_to='+this.filter_date_to+''">
                                            <strong>{{ sub_level.name }}</strong>
                                        </router-link>
                                    </td>
                                    <td class="meeting-status-number decided">
                                        {{ parseMeetingStatusText(sub_level.meeting_status)[0] }}
                                    </td>
                                    <td class="meeting-status-number confirmed">
                                        {{ parseMeetingStatusText(sub_level.meeting_status)[1] }}
                                    </td>
                                    <td class="meeting-status-number happened">
                                        {{ parseMeetingStatusText(sub_level.meeting_status)[2] }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>

            <template v-else-if="user_level <= 2">
                <router-link 
                    :to="'/org/' + (user_level + 1) + '/' + sub_level.id + '/meeting-report?meeting_type='+this.filter_meeting+'&&date_from='+this.filter_date_from+'&&date_to='+this.filter_date_to+''"
                    class="mobile-report-card mobile-report-card-clickable"
                    v-for="sub_level in member_lists" 
                    v-bind:key="sub_level.id"
                    tag="div"
                >
                    <div class="mobile-card-header">
                        <div class="mobile-name">
                            <span class="name-text">{{ sub_level.name }}</span>
                        </div>
                    </div>
                    
                    <div class="mobile-card-body">
                        <div class="mobile-status-section">
                            <div class="mobile-status-content">
                                <template v-if="user_level <= 2">
                                    <div class="status-chips" v-if="sub_level.meeting_status">
                                        <span class="chip chip-decided">{{ $t('decided') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[0] }}</span>
                                        <span class="chip chip-confirmed">{{ $t('confirmed') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[1] }}</span>
                                        <span class="chip chip-happened">{{ $t('happened') }}: {{ parseMeetingStatusText(sub_level.meeting_status)[2] }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <span v-html="sub_level.meeting_status"></span>
                                </template>
                                <span v-if="sub_level.meeting_date" class="meeting-date-badge" v-html="sub_level.meeting_date"></span>
                            </div>
                        </div>

                        <div class="mobile-attendance-section">
                            <div class="mobile-label">{{ $t('attendance') }}</div>
                            <div class="mobile-attendance-grid">
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-ws">WS</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.wisdom }}/{{ sub_level.wing_counts.wisdom_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-yt">YT</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.youth }}/{{ sub_level.wing_counts.youth_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-st">ST</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.students }}/{{ sub_level.wing_counts.students_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-wm">WM</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.women }}/{{ sub_level.wing_counts.women_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-gl">GL</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.girls }}/{{ sub_level.wing_counts.girls_total }}</span>
                                </div>
                            </div>
                            <div class="mobile-attendance-total" v-if="sub_level.attendance">
                                <span class="total-label">Total:</span>
                                <span class="total-value">{{ sub_level.attendance }}</span>
                            </div>
                        </div>
                    </div>
                </router-link>
            </template>
            <template v-else>
                <div 
                    class="mobile-report-card"
                    v-for="sub_level in member_lists" 
                    v-bind:key="sub_level.id"
                >
                    <div class="mobile-card-header">
                        <div class="mobile-name">
                            <span class="name-text">{{ sub_level.name }}</span>
                        </div>
                    </div>
                    
                    <div class="mobile-card-body">
                        <div class="mobile-status-section">
                            <div class="mobile-status-content">
                                <span v-html="sub_level.meeting_status"></span>
                                <span v-if="sub_level.meeting_date" class="meeting-date-badge" v-html="sub_level.meeting_date"></span>
                            </div>
                        </div>

                        <div class="mobile-attendance-section">
                            <div class="mobile-label">{{ $t('attendance') }}</div>
                            <div class="mobile-attendance-grid">
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-ws">WS</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.wisdom }}/{{ sub_level.wing_counts.wisdom_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-yt">YT</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.youth }}/{{ sub_level.wing_counts.youth_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-st">ST</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.students }}/{{ sub_level.wing_counts.students_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-wm">WM</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.women }}/{{ sub_level.wing_counts.women_total }}</span>
                                </div>
                                <div class="mobile-attendance-item">
                                    <span class="attendance-badge badge-gl">GL</span>
                                    <span class="attendance-value">{{ sub_level.wing_counts.girls }}/{{ sub_level.wing_counts.girls_total }}</span>
                                </div>
                            </div>
                            <div class="mobile-attendance-total" v-if="sub_level.attendance">
                                <span class="total-label">Total:</span>
                                <span class="total-value">{{ sub_level.attendance }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field } from "vee-validate";
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import moment from 'moment';
export default {
    name: 'Nerpatham Report',
    components: {
        Form,
        Field,
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            meeting_list: [
                {
                    'id' : 1,
                    'name' : 'Secretariate'
                },
                {
                    'id' : 2,
                    'name' : 'Executive'
                },
                {
                    'id' : 3,
                    'name' : 'Departmental'
                },
                {
                    'id' : 4,
                    'name' : 'General Body'
                },
                {
                    'id' : 5,
                    'name' : 'Council'
                },
                {
                    'id' : 6,
                    'name' : 'Joint Secretariat'
                },
                {
                    'id' : 7,
                    'name' : 'Wisdom Day'
                },
                {
                    'id' : 8,
                    'name' : 'Special Meetings'
                },
            ],
            filter_meeting: '',
            filter_region: 'kerala',
            // "Not held" report (state admin, Wisdom Day) — driven by the applied Search filter
            nh_open: false,
            nh_loading: false,
            nh_loaded: false,
            nh_view: 'zones',   // 'zones' | 'units'
            nh_zones: [],
            nh_units: [],
            nh_unit_zone_filter: '',   // zone_id filter for the units list
            nh_collapsed_zones: {},    // zone_key -> collapsed? (units accordion)
            nh_searched_meeting: '',   // meeting type that was actually searched
            nh_from: '',               // searched date range (captured on Search)
            nh_to: '',
            nh_region_used: 'kerala',
            filter_date_from: '',
            filter_date_to: '',
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: '',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            count_total: 0,
            count_target: 0,
            level: [],
            nerpatham_target: '',
            target_title: 'ടാർഗറ്റ്',
            page_title: 'വർക്കിങ് ഫണ്ട് റിപ്പോർട്ട്',
            series: [0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#64b167', '#db7491'],
                labels: ['Target', 'Total'],
                responsive: [{
                    breakpoint: 100,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            count_state: 0,
            count_unit: 0,
            count_zone: 0,
            count_district: 0,
            count_confirmed: 0.00,

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Show the "not held" report only for state admin AFTER a Wisdom Day (sublevel 7) search
        showNotHeldReport() {
            return this.user_level === 1 && String(this.nh_searched_meeting) === '7';
        },
        // Zones-not-held grouped by district
        nhZonesByDistrict() {
            const map = {};
            (this.nh_zones || []).forEach(z => {
                const key = z.district_id || ('n_' + z.district_name);
                if (!map[key]) map[key] = { district_name: z.district_name || 'Unknown', zones: [] };
                map[key].zones.push(z);
            });
            return Object.values(map);
        },
        // Distinct zones present in the not-held units list (for the dropdown)
        nhUnitZoneOptions() {
            const map = {};
            (this.nh_units || []).forEach(u => {
                const key = u.zone_id || ('n_' + u.zone_name);
                if (!map[key]) map[key] = { zone_id: u.zone_id, zone_name: u.zone_name || 'Unknown', district_name: u.district_name || '', count: 0 };
                map[key].count++;
            });
            return Object.values(map).sort((a, b) =>
                (a.district_name || '').localeCompare(b.district_name || '') || (a.zone_name || '').localeCompare(b.zone_name || '')
            );
        },
        // Units-not-held grouped by district → zone (respects the zone dropdown filter)
        nhUnitsByDistrict() {
            const dmap = {};
            let units = this.nh_units || [];
            if (this.nh_unit_zone_filter !== '') {
                units = units.filter(u => String(u.zone_id) === String(this.nh_unit_zone_filter));
            }
            units.forEach(u => {
                const dkey = u.district_id || ('n_' + u.district_name);
                if (!dmap[dkey]) dmap[dkey] = { district_name: u.district_name || 'Unknown', zones: {} };
                const zkey = u.zone_id || ('n_' + u.zone_name);
                if (!dmap[dkey].zones[zkey]) dmap[dkey].zones[zkey] = { zone_key: String(zkey), zone_id: u.zone_id, zone_name: u.zone_name || 'Unknown', units: [] };
                dmap[dkey].zones[zkey].units.push(u);
            });
            return Object.values(dmap).map(d => ({ district_name: d.district_name, zones: Object.values(d.zones) }));
        },
        isCompactStatusTableView() {
            // Apply the compact table layout for State + District screens.
            // Keep unit-level (next screen) in the existing old design.
            return this.user_level === 1 || this.user_level === 2;
        },
        compactTableNameLabel() {
            // State shows districts; district shows zones
            if (this.user_level === 1) return this.$t('district');
            if (this.user_level === 2) return this.$t('zone');
            return this.$t('name');
        },
        confirmedHeaderHtml() {
            // Make Malayalam "ഷെഡ്യൂൾ ചെയ്തത്" (or any 2+ word label) wrap cleanly in two lines
            const text = String(this.$t('confirmed') || '').trim();
            const parts = text.split(/\s+/);
            if (parts.length >= 2) {
                return `${parts[0]}<br>${parts.slice(1).join(' ')}`;
            }
            return text;
        },
        minusToZero() {
            let value = this.count_target - this.count_total;
            if (value <= 0) {
                return '0';
            } else {
                return value.toFixed(2);
            }
        },
    },
    watch: {
        $route() {
            this.applyRouteFilters();
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.applyRouteFilters();

            this.$root.updateParent('Meeting Report');
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };

        // Re-apply filters when user navigates back to this page
        window.addEventListener('popstate', this.applyRouteFilters);
    },
    beforeUnmount() {
        window.removeEventListener('popstate', this.applyRouteFilters);
    },
    methods: {
        applyRouteFilters() {
            const q = (this.$route && this.$route.query) ? this.$route.query : {};
            let meeting = q.meeting_type || '';
            let from = q.date_from || '';
            let to = q.date_to || '';
            let region = q.region || '';
            // No query params (e.g. Back navigation to the top page) → restore last-used filters
            if (!meeting && !from && !to) {
                try {
                    const saved = JSON.parse(localStorage.getItem('meetingReportFilters') || 'null');
                    if (saved) {
                        meeting = saved.meeting || '';
                        from = saved.date_from || '';
                        to = saved.date_to || '';
                        region = saved.region || '';
                    }
                } catch (e) { /* ignore */ }
            }
            this.filter_date_from = from || moment(new Date()).format('YYYY-MM-DD');
            this.filter_date_to = to || moment(new Date()).format('YYYY-MM-DD');
            if (meeting) this.filter_meeting = meeting;
            if (region) this.filter_region = region;
            if (this.filter_meeting && this.filter_date_from && this.filter_date_to) {
                this.getMembersList();
            }
        },
        parseMeetingStatusText(statusHtml) {
            if (!statusHtml) return [0, 0, 0];
            // Strip any HTML tags and whitespace
            const text = String(statusHtml).replace(/<[^>]*>/g, '').trim();
            const parts = text.split('/')
                .map(p => p && p.replace(/[^0-9]/g, ''))
                .map(n => (n === '' || n == null ? 0 : parseInt(n)));
            return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
        },
        updateChart() {
            this.chartOptions = {
                chart: {
                    type: 'pie'
                },
                colors: ['#64b167', '#db7491'],
                labels: ['ചേർത്തത്', 'ബാക്കി ഉള്ളത്'],
                responsive: [{
                    breakpoint: this.count_target,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            show: false,
                        }
                    }
                }]
            }
            // In the same way, update the series option
            this.series = [parseFloat(this.count_total), parseFloat(this.count_target - this.count_total)]
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            this.name = admin.name;
            this.mobile = admin.mobile;
            this.subscription_no = admin.subscription_no;
            this.receipt_no = admin.reciept_no;
            this.member_edit = false;
            this.member_list.push(this.member);
            this.designation = admin.designation;
            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.disable_member_form = false;
            this.message = '';
            this.member_id = '';
            this.name = '';
            this.mobile = '';
            this.subscription_no = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.member = '';
            this.editable_id = null;
            this.add_admin = true;
            this.edit_admin = false;
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            console.log(user);
            user.editable_id = this.editable_id;
            user.is_member = this.isMember;
            if (!this.member && this.isMember == 'Y') {
                this.message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക';
            }
            if (this.member) {
                user.member_id = this.member.id;
            }
            user.unit_id = parseInt(this.$route.params.id);
            UserService.addAdmin('store-nerpatham-subscriptions', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delate-nerpatham-subscriptions', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getWing(wing) {
            if (wing == 1)
                return 'വിസ്‌ഡം';
            else if (wing == 2)
                return 'യൂത്ത്';
            else if (wing == 3)
                return 'സ്റ്റുഡന്റസ്';
            else if (wing == 4)
                return 'വിമെൻ';
            else
                return 'ഗേൾസ്';
        },
        toggleNotHeldReport() {
            this.nh_open = !this.nh_open;
            if (this.nh_open && !this.nh_loaded) this.loadNotHeld();
        },
        isNhZoneCollapsed(key) {
            // default collapsed (units hidden until the zone row is clicked)
            return this.nh_collapsed_zones[key] !== false;
        },
        toggleNhZone(key) {
            this.nh_collapsed_zones[key] = !this.isNhZoneCollapsed(key);
        },
        loadNotHeld() {
            // Uses the date range captured at Search time (not the live filter inputs).
            this.nh_loading = true;
            const data = {
                meeting: this.nh_searched_meeting,
                date_from: this.nh_from,
                date_to: this.nh_to,
                region: this.nh_region_used,
            };
            UserService.authPostRequest('get-meeting-not-held-report', data).then(
                (response) => {
                    this.nh_loading = false;
                    if (response.data.status === 'success') {
                        this.nh_zones = response.data.data.zones_not_held || [];
                        this.nh_units = response.data.data.units_not_held || [];
                        this.nh_loaded = true;
                    }
                },
                () => { this.nh_loading = false; }
            );
        },
        getMembersList() {
            let data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                meeting: this.filter_meeting,
                date_from: this.filter_date_from,
                date_to: this.filter_date_to,
                region: this.filter_region
            }
            if (!this.filter_meeting) {
                this.alert_type = 'Warning';
                this.alert_message = 'മീറ്റിംഗ് ടൈപ്പ് സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            } else if (!this.filter_date_from) {
                this.alert_type = 'Warning';
                this.alert_message = 'തീയതി സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            } else if (!this.filter_date_to) {
                this.alert_type = 'Warning';
                this.alert_message = 'തീയതി സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            }
            this.loading_list = true;

            // Capture what was actually searched so the "not held" report matches the applied filter,
            // and reset it so it reloads (collapsed) for the new search.
            this.nh_searched_meeting = this.filter_meeting;
            this.nh_from = this.filter_date_from;
            this.nh_to = this.filter_date_to;
            this.nh_region_used = this.filter_region;
            this.nh_open = false;
            this.nh_loaded = false;
            this.nh_zones = [];
            this.nh_units = [];
            this.nh_unit_zone_filter = '';
            this.nh_collapsed_zones = {};

            // Persist filters so they survive Back-navigation from a drilled-down page
            try {
                localStorage.setItem('meetingReportFilters', JSON.stringify({
                    meeting: this.filter_meeting,
                    date_from: this.filter_date_from,
                    date_to: this.filter_date_to,
                    region: this.filter_region,
                }));
            } catch (e) { /* ignore */ }

            UserService.authPostRequest(`get-meeting-report`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.meeting_list = response.data.data.meetings;
                        this.member_lists = response.data.data.list;
                        this.level = response.data.data.level;
                        this.count_target = response.data.data.count_target;
                        this.count_total = response.data.data.count_total;
                        this.count_confirmed = response.data.data.count_confirmed;
                        this.loading_list = false;
                        // this.updateChart();
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        showActionModel() {
            this.pin_number = '';
        },
        nerpathamTarget(sub_level = null) {
            this.nerpatham_target = sub_level.nerpatham_target;
            this.sub_level_id = sub_level.id;
            $('#nerpathamTargetModel').modal('show');
        },
        addNerpathamTarget(data) {
            data.level = parseInt(this.$route.params.sub_level) + 1;
            data.level_id = parseInt(this.sub_level_id);
            UserService.addAdmin('set-nerpatham-target', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.getMembersList();
                        $('#nerpathamTargetModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        clearFilter(){
            this.filter_meeting = '';
            this.filter_date_from = moment(new Date()).format('YYYY-MM-DD');
            this.filter_date_to = moment(new Date()).format('YYYY-MM-DD');
            // hide the not-held report until a new search is run
            this.nh_searched_meeting = '';
            this.nh_open = false;
            this.nh_loaded = false;
            this.nh_zones = [];
            this.nh_units = [];
            // forget persisted filters
            try { localStorage.removeItem('meetingReportFilters'); } catch (e) { /* ignore */ }
        }
    },
};
</script>
<style scoped>
.nh-tab {
    flex: 1;
    padding: 6px 6px;
    border: none;
    border-radius: 7px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    cursor: pointer;
}
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.stat-box .value {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1em;
    color: #27173E;
}


.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 26px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px !important;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 0px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 10px;
    position: relative;
    z-index: 1;
}
.badge {
    border-radius: 0px !important;
}
.back-color-primary{
    background: #1a418c !important;
}

.back-color-secondary{
    background: #666d79 !important;
}
.back-color-danger{
    background: #de6f56 !important;
}
.back-color-warning{
    background: #b19547 !important;
}
.back-color-red{
    background: #d55454  !important;
}

.back-color-violet{
    background: #0000A3  !important;
}

.back-color-blue1{
    background: #0000D1  !important;
}
.back-color-blue2{
    background: #0000FF  !important;
}
.back-color-blue3{
    background: #2E2EFF  !important;
}
.back-color-blue4{
    background: #5C5CFF  !important;
}
.back-color-blue5{
    background: #8A8AFF  !important;
}
.back-color-blue6{
    background: #8F00FF  !important;
}

/* Classic Report Table Styles */
.report-container {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.table-classic {
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;
    font-size: 14px;
}

.table-classic thead {
    background: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.table-classic thead th {
    padding: 14px 16px;
    text-align: left;
    font-weight: 600;
    color: #27173E;
    border-bottom: 2px solid #dee2e6;
    font-size: 13px;
    line-height: 1.4;
}

.table-classic thead th.col-name {
    text-align: left;
    padding-left: 20px;
}

.table-classic thead th.col-status {
    text-align: center;
}

.table-classic thead th.col-attendance {
    text-align: right;
    padding-right: 20px;
}

.header-multiline {
    line-height: 1.5;
}

.table-classic tbody tr.report-row {
    border-bottom: 1px solid #e9ecef;
    transition: background-color 0.2s ease;
}

.table-classic tbody tr.report-row:hover {
    background-color: #f8f9fa;
}

.table-classic tbody tr.report-row:last-child {
    border-bottom: none;
}

.table-classic tbody td {
    padding: 16px;
    vertical-align: top;
    color: #495057;
}

.table-classic .cell-name {
    text-align: left;
    padding-left: 20px;
    font-weight: 600;
    color: #27173E;
    min-width: 150px;
}

.table-classic .cell-name .name-link a,
.table-classic .cell-name .name-text {
    color: #1a418c;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
}

.table-classic .cell-name .name-link a:hover {
    text-decoration: underline;
    color: #0d2b5c;
}

.table-classic .cell-status {
    text-align: left;
    padding: 16px 12px;
}

.status-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.status-content span {
    display: block;
    font-size: 13px;
    color: #495057;
}

.meeting-date-badge {
    display: inline-block;
    padding: 3px 8px;
    background: rgba(17, 24, 39, 0.06);
    color: #374151;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    margin-top: 2px;
}

.table-classic .cell-attendance {
    text-align: right;
    padding-right: 20px;
    padding-left: 16px;
}

.attendance-list {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

.attendance-item {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    font-size: 13px;
    min-width: 120px;
}

.attendance-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #ffffff;
    font-weight: 600;
    font-size: 11px;
    flex-shrink: 0;
    line-height: 1;
}

.attendance-badge.badge-ws {
    background: #1a418c;
}

.attendance-badge.badge-yt {
    background: #28a745;
}

.attendance-badge.badge-st {
    background: #dc3545;
}

.attendance-badge.badge-wm {
    background: #6c757d;
}

.attendance-badge.badge-gl {
    background: #6c757d;
}

.attendance-value {
    color: #495057;
    font-weight: 500;
    min-width: 70px;
    text-align: right;
    white-space: nowrap;
    font-size: 13px;
}

.attendance-total {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}

.attendance-total .total-label {
    color: #6c757d;
    font-size: 12px;
}

.attendance-total .total-value {
    color: #27173E;
    font-size: 14px;
}

/* Mobile and Desktop View Toggle */
.desktop-view {
    display: block;
}

.mobile-view {
    display: none;
}

/* Mobile Card Styles */
.mobile-view {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.mobile-report-card {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.mobile-report-card-clickable {
    cursor: pointer;
    text-decoration: none;
    display: block;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.mobile-report-card-clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mobile-report-card-clickable:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.mobile-report-card-clickable * {
    text-decoration: none;
}

.mobile-card-header {
    background: #f8f9fa;
    padding: 14px 16px;
    border-bottom: 2px solid #dee2e6;
}

.mobile-name {
    font-weight: 600;
    font-size: 15px;
    color: #27173E;
}

.mobile-name .name-text {
    color: #27173E;
    text-decoration: none;
    font-weight: 600;
}

.mobile-report-card-clickable .mobile-name .name-text {
    color: #1a418c;
}

.mobile-report-card-clickable:hover .mobile-name .name-text {
    color: #0d2b5c;
}

.mobile-card-body {
    padding: 16px;
}

.mobile-status-section,
.mobile-attendance-section {
    margin-bottom: 16px;
}

.mobile-status-section:last-child,
.mobile-attendance-section:last-child {
    margin-bottom: 0;
}

.mobile-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    display: block;
}

.mobile-status-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    display: flex;
    padding: 4px 10px;
}

/* Labeled chips for status */
.status-chips {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.chip {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
}

.chip-decided {
    background: #dbeafe; /* blue-100 */
    color: #1e40af;      /* blue-800 */
    border: 1px solid #bfdbfe; /* blue-200 */
}

.chip-confirmed {
    background: #dcfce7; /* green-100 */
    color: #166534;      /* green-800 */
    border: 1px solid #bbf7d0; /* green-200 */
}

.chip-happened {
    background: #ede9fe; /* violet-100 */
    color: #5b21b6;      /* violet-800 */
    border: 1px solid #ddd6fe; /* violet-200 */
}

.table-meeting-status .cell-status-number {
    text-align: center;
    font-weight: 800;
    font-size: 14px;
    color: #111827;
}

.table-meeting-status .cell-status-number.decided {
    color: #b45309; /* amber-700 */
}

.table-meeting-status .cell-status-number.confirmed {
    color: #1d4ed8; /* blue-700 */
}

.table-meeting-status .cell-status-number.happened {
    color: #15803d; /* green-700 */
}

.table-meeting-status thead th {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 1.1;
}

.meeting-status-card {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.meeting-status-table th {
    font-size: 11px;
    text-align: center;
    background-color: #f8f9fa;
    font-weight: 600;
    vertical-align: middle;
    padding: 5px 4px;
    line-height: 1.1;
}

.meeting-status-table td {
    text-align: center;
    font-size: 13px;
    vertical-align: middle;
    padding: 8px 4px;
    line-height: 1.25;
}

.meeting-status-name {
    text-align: left !important;
    white-space: nowrap;
}

.meeting-status-number {
    font-weight: 800;
    font-size: 14px;
}

.meeting-status-number.decided { color: #1e40af; }
.meeting-status-number.decided { color: #b45309; } /* amber-700 */
.meeting-status-number.confirmed { color: #1d4ed8; } /* blue-700 */
.meeting-status-number.happened { color: #15803d; } /* green-700 */

.mobile-status-content span {
    font-size: 13px;
    color: #495057;
    font-weight: bolder;
}

.mobile-attendance-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-bottom: 12px;
    align-items: stretch;
}

.mobile-attendance-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 6px;
    background: #f8f9fa;
    border-radius: 6px;
    min-height: 52px;
    flex-direction: column;
    text-align: center;
}

.mobile-attendance-item .attendance-badge {
    width: 36px;
    height: 36px;
    font-size: 11px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.mobile-attendance-item .attendance-value {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    line-height: 1.2;
}

.mobile-attendance-total {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 2px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    padding-bottom: 4px;
}

.mobile-attendance-total .total-label {
    color: #6c757d;
    font-size: 13px;
}

.mobile-attendance-total .total-value {
    color: #27173E;
    font-size: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .desktop-view {
        display: none !important;
    }
    
    .mobile-view {
        display: flex !important;
    }
    
    .mobile-attendance-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
    
    .mobile-attendance-item {
        padding: 10px 6px;
        min-height: 52px;
        gap: 6px;
    }
    
    .mobile-attendance-item .attendance-badge {
        width: 32px;
        height: 32px;
        font-size: 10px;
    }
    
    .mobile-attendance-item .attendance-value {
        font-size: 11px;
    }
}

@media (max-width: 480px) {
    .mobile-card-header {
        padding: 12px 14px;
    }
    
    .mobile-card-body {
        padding: 14px;
    }
    
    .mobile-attendance-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
    }
    
    .mobile-attendance-item {
        padding: 8px 4px;
        min-height: 50px;
        gap: 5px;
    }
    
    .mobile-attendance-item .attendance-badge {
        width: 30px;
        height: 30px;
        font-size: 9px;
    }
    
    .mobile-attendance-item .attendance-value {
        font-size: 10px;
    }
    
    .mobile-name {
        font-size: 14px;
    }
    
    .mobile-label {
        font-size: 10px;
    }
    
    .mobile-status-content span {
        font-size: 12px;
    }
}

@media (max-width: 576px) {
    .meeting-status-table th,
    .meeting-status-table td {
        font-size: 11px;
        padding: 5px 2px;
    }

    .meeting-status-number {
        font-size: 14px;
    }
}

@media (max-width: 420px) {
    .meeting-status-table th,
    .meeting-status-table td {
        font-size: 10px;
        padding: 4px 2px;
    }

    .meeting-status-number {
        font-size: 13px;
    }
}
</style>